import Joyride, { type CallBackProps } from "react-joyride";
import {
  TOUR_DEFAULT_PROPS,
  TOUR_LOCALE,
  TOUR_STYLES,
} from "@/shared/tour/config";
import { rolesTourSteps } from "./tourSteps";

type RolesTourProps = {
  run: boolean;
  onCallback: (data: {
    status?: string;
    type?: string;
    index?: number;
    action?: string;
  }) => void;
};

export function RolesTour({ run, onCallback }: RolesTourProps) {
  const handleCallback = (data: CallBackProps) => {
    const { status, type, index, action } = data;
    onCallback({ status, type, index, action });
  };

  return (
    <Joyride
      steps={rolesTourSteps}
      run={run}
      callback={handleCallback}
      locale={TOUR_LOCALE}
      styles={TOUR_STYLES}
      {...TOUR_DEFAULT_PROPS}
    />
  );
}

export { useRolesTour } from "./useRolesTour";
